import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Space, Table, Tag, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { formatDate } from '@/lib/format';
import { formatRupiah } from '@/lib/format';
import { useAuthStore } from '@/lib/auth-store';
export function JournalListPage() {
    const hasPerm = useAuthStore((s) => s.hasPerm);
    const q = useQuery({
        queryKey: ['journals'],
        queryFn: async () => (await api.get('/journals', { params: { size: 100 } })).data,
    });
    const cols = [
        {
            title: 'Nomor',
            dataIndex: 'number',
            width: 180,
            render: (n, r) => _jsx(Link, { to: `/accounting/journals/${r.id}`, children: n }),
        },
        { title: 'Tanggal', dataIndex: 'tx_date', width: 120, render: (d) => formatDate(d) },
        { title: 'Memo', dataIndex: 'memo' },
        {
            title: 'Sumber',
            dataIndex: 'source_type',
            width: 130,
            render: (s) => _jsx(Tag, { children: s }),
        },
        {
            title: 'Total',
            dataIndex: 'total_debit',
            width: 160,
            align: 'right',
            render: (d) => _jsx("span", { className: "money", children: formatRupiah(d) }),
        },
        {
            title: 'Status',
            width: 130,
            render: (_, r) => {
                if (r.reverses)
                    return _jsx(Tag, { color: "orange", children: "Reversal" });
                if (r.reversed_by)
                    return _jsx(Tag, { color: "magenta", children: "Direvers" });
                if (r.posted_at)
                    return _jsx(Tag, { color: "success", children: "Posted" });
                return _jsx(Tag, { children: "Draft" });
            },
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Jurnal" }), hasPerm('journal:create') && (_jsx(Link, { to: "/accounting/journals/new", children: _jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), children: "Buat Jurnal Baru" }) }))] }), _jsx(Table, { rowKey: "id", loading: q.isLoading, dataSource: q.data ?? [], columns: cols, size: "middle", pagination: { pageSize: 25 } })] }));
}
